(function () {
    'use strict';

    realmCommerceApp.controller("CustomerForgotPasswordController", CustomerForgotPasswordController);

    /*@ngInject*/
    function CustomerForgotPasswordController() {
        var vm = this;
        vm.forgotPasswordModel = {};
        vm.forgotPasswordFields = [
            {
                key: 'username',
                name: 'username',
                type: 'input',
                templateOptions: {
                    labelOptions: {
                        label: 'Email Address'
                    },
                    placeholder: 'Email Address',
                    required: true,
                    type: "email"
                }
            }
        ];
    }
})();




// WEBPACK FOOTER //
// ./static/js/app/customer/customer.forgotpassword.controller.js